import { api } from './api';

/** Follow a task — the current user gets in-app notifications on its activity. */
export async function subscribeTask(key: string): Promise<{ subscribed: boolean }> {
  const { data } = await api.post<{ subscribed: boolean }>(`/tasks/${key}/subscribe`);
  return data;
}

/** Unfollow a task. */
export async function unsubscribeTask(key: string): Promise<{ subscribed: boolean }> {
  const { data } = await api.delete<{ subscribed: boolean }>(`/tasks/${key}/subscribe`);
  return data;
}
